<template>
  <div class="lucky-numbers__market-contents">
    <div class="lucky-numbers__market-payout">
      <div
          v-for="(market, index) in listPayouts"
          :key="index"
      >
        <div class="lucky-numbers__market-payout-title">
          {{ market.description }}
        </div>
        <div class="lucky-numbers__market-payout-content">
          <div class="lucky-numbers__market-payout-fields">
            <div class="lucky-numbers__market-payout-fields-ball">
              No. of balls
            </div>
            <div class="lucky-numbers__market-payout-fields-odds">
              UK Odds
            </div>
          </div>
          <div class="lucky-numbers__market-payout-items">
          </div>
          <div
              v-for="(item, index) in market.outcomes"
              :key="index"
              class="lucky-numbers__market-payout-item">
            <div class="lucky-numbers__market-payout-item-number">
              {{ item.short_text }}
            </div>
            <div class="lucky-numbers__market-payout-item-odds">
              {{ $filters.formatNumber(item.odds) }}
            </div>
            <div class="lucky-numbers__market-payout-item-buttons">
              <button @click="$emit('quickPick', {value: item, market: market})">Quick Pick</button>
<!--              <button :class="{active: item.isFav}" @click="$emit('myFav', {market, odds: item.odds})">My Fav</button>-->
            </div>
          </div>
<!--          <div class="lucky-numbers__market-payout-fields">-->
<!--            <div class="lucky-numbers__market-payout-fields-ball">-->
<!--              Bonus ball-->
<!--            </div>-->
<!--            <div class="lucky-numbers__market-payout-fields-odds">-->
<!--              UK Odds-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="lucky-numbers__market-ball">
      <div class="lucky-numbers__market-ball-title">
        BALL SELECTION
      </div>
      <div class="lucky-numbers__market-ball-content">
        <TabsSwift
          :numbersMainBallSet="numbersMainBallSet"
          :numbersPowerBallSet="numbersPowerBallSet"
          :tabs="tabsMainMarket"
          @handleChosenItem="handleChosenNumber"
          @handleAddLine="$emit('handleAddLine')"
        />
        <TabsSwift
            v-if="tabsMoreMarket.length > 0"
            :numbersMainBallSet="numbersMainBallSet"
            :numbersPowerBallSet="numbersPowerBallSet"
            :tabs="tabsMoreMarket"
            @handleChosenItem="handleChosenNumber"
            @handleAddLine="$emit('handleAddLine')"
        />
      </div>
    </div>
    <BallChosen
        :title="'YOUR CHOSEN LINES ARE'"
        :dataChosen="listChosen"
        @delete-item="handleConfirmDeleteItemChosen"
        @clickAddBetslip="$emit('clickAddBetslip')"
        @clickViewBetslip="$emit('clickViewBetslip')"
    />
<!--    <ModalConfirm-->
<!--        v-if="isShowModalConfirmDelete"-->
<!--        :id="idItemDelete"-->
<!--        @close="$emit('cancelDeleteItem')"-->
<!--        @delete="$emit('handleDeleteItemChosen')"-->
<!--    />-->
  </div>
</template>
<script>
import TabsSwift from '@/components/common/tabs/tabs-swift.vue';
import BallChosen from '@/components/common/ball/ball-chosen.vue';
// import ModalConfirm from '@/components/common/modal/modal-confirm.vue';
import TabMainBallSet from "./TabMainBallSet";
import TabPowerBallSet from "./TabPowerBallSet";
export default {
  props: {
    listPayouts: {
      type: Array,
      default: () => []
    },
    numbersMainBallSet: {
      type: Array,
      default: () => []
    },
    numbersPowerBallSet: {
      type: Array,
      default: () => []
    },
    listChosen: {
      type: Array,
      default: () => []
    },
    isShowModalConfirmDelete: {
      type: Boolean,
      default: false
    },
    isPowerBall: {
      type: Boolean,
      default: false
    },
    tabsNumber: {
      type: Array,
      default: () => []
    },
    tabsMainMarket: {
      type: Array,
      default: () => []
    },
    tabsMoreMarket: {
      type: Array,
      default: () => []
    }
  },
  components: {
    TabsSwift,
    BallChosen,
    // ModalConfirm
  },
  computed: {
    markets() {
      return this.$store.getters.getMarkets
    },
  },
  watch: {
    isPowerBall() {
      this.tabs = [
        {
          title: 'MAIN BALL SET',
          href: 'main-ball-set',
          isActive: true,
          component: TabMainBallSet,
          classCustom: 'tab-main-ball-set tab-ball-set-common'
        }
      ]
    }
  },
  methods: {
    handleChosenNumber(value) {
      this.$emit('handleChosenItem', value)
    },
    handleConfirmDeleteItemChosen(index) {
      this.$emit('handleConfirmDeleteItemChosen', index)
    }
  }
}
</script>
